export class VisitaEvolucaoFiltrosDTO {
    semanal: boolean;
    qtdeMeses: number;
    idsVisitantes: number[];
}